export enum UploadFileName {
   PO = "PO",
   INVOICE ="INVOICE",
   GRN ="GRN"
}